// extracted by mini-css-extract-plugin
module.exports = {"title":"DeletePlan_title__3t6Qe","marginTop":"DeletePlan_marginTop__kZuto","btn":"DeletePlan_btn__uvqSz"};